import React, { useState, useEffect } from "react";
import { withOidcSecure } from "@axa-fr/react-oidc";
import { width } from "../../../CustomComponents/DynamicCard/DynamicCardStyles";
import { useTranslation } from "react-i18next";
import HomeLayout from "../../../Layout/HomeLayout";
import DynamicCard from "../../../CustomComponents/DynamicCard";
import { useNavigate } from "react-router";
import LineBreaks, {
  addLineBreaks,
  ClimbManageSettingsSidebar,
  retrieveData,
} from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../CustomComponents/Loader";
import SuccesRemoveGoal from "../SuccesRemoveGoal";
import {
  EDIT_MANAGE_SAVIGN,
  GET_ALL_SPEND_ALERTS,
  GET_CLIMB_FEATURES,
  GET_MANAGE_SAVING_GOAL,
  SAVING_CARD_CODE,
  SAVINGS_GOALS,
  SPENDING_ALERT,
  STATUS_SUCCESS_CODE,
  EDIT_MANAGE_SAVIGN_V2,
} from "../../../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  GetRequest,
  PostRequest,
} from "../../../../network/NetworkUtils";
import checkbox_fill from "../../../../assets/images/Checkbox-blue.png";
import side from "../../../../assets/kudzu-plus-images/arrow-image.png";
import {
  appTheme,
  frequencyDataConverted,
} from "../../../../helpers/utils/Utils";
import CardHeading from "../../../CustomComponents/CardHeading";
import ProgressBar from "../../../CustomComponents/ProgressBar";
import ArrowIcon from "../../../../assets/kudzu-plus-images/arrow_icon_saving_goal.png";
import moment from "moment";
import logFirebaseEvents from "../../../LogFirebaseEvents";
import CustomRadioButton from "../../../CustomComponents/CustomRadioButton";
import CustomDatePicker from "../../../CustomComponents/CustomDateInput";
import CustomAllocateFundDropdown from "../../../CustomComponents/CustomAllocateFundDropdown";
import AllocateFundSubItemConfirmationCard from "../SpendSenseAlerts/ConfirmationCard/AllocateFundSubItemConfirmationCard";
import EditAndRemoveGoals from "../SpendSenseAlerts/ConfirmationCard/EditAndRemoveGoal";
import SavingGoalsAleart from "../AddSavingGoal/SavingGoalsAleart";
import Modal from "../../../CustomComponents/Modal";
import EditSuccessModal from "../AddSavingGoal/EditSuccessModal";
import EditErrorModal from "../AddSavingGoal/EditErrorModal";
import HelpPlus from '../../../../assets/kudzu-plus-images/HelpPlus.png';
import CustomDropdown from "../../../CustomComponents/CustomDropDown";
import { displayErrorMessage } from "../../../../utils";
import Success from "../Success";
import SuccessRemoveGoalConfirm from "../SuccessRemoveGoalConfirm";
import DoneModalGoalRemove from "../DoneModalGoalRemove";
import TransferErrorModal from "../AddSavingGoal/TransferErrorModal";
import { REMOVESAVINGGOAL } from "../../../../network/URLConstants";
import { dateComparison } from "../../../../utils";
import { GET_BALANACE_ALLOCATE } from "../../../../network/URLConstants";
import CompletedDoneModalGoalRemove from "../CompletedDoneModalGoalRemove";

const EditManageSaving = ({ cardHeader, onBack, onEdit, onSave }) => {
  const [doneModal, setDoneModalOpen] = useState(false);
  const HeadingStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--oops-edit-clr)]";
  const SubHeadingStyles =
    "font-serif-pro modal-title lg:text-[33px] md:text-[33px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-edit-spendsense)] md:w-[80%]";
  const [errorModalDouble, setErrorModalDouble] = useState(false);
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [spendAlertsArray, setspendAlertsArray] = useState(null);
  const [showSubItems, setShowSubItems] = useState(false);
  const [isClimbings, setisClimbings] = useState([]);
  const [isOptIn, setIsOptIn] = useState("");
  const [SpendingAlertCode, setSpendingAlertCode] = useState("");
  const [SpendingCount, setSpendingCount] = useState(0);
  const [errorModal, setErrorModal] = useState(false);
  const [responseErrorMsg, setResponseErrorMsg] = useState("");

  const [successModal, setSuccessModal] = useState(false);
  const [errorModalConfirm, setErrorModalConfirm] = useState(false);
  const climbFeatures = useSelector((state) => state.climbFeatures);
  const enabledClimbings = climbFeatures?.filter(
    (response) => response.enabled === true
  );
  const isCoveredByKudzuOptedIn = enabledClimbings?.some(
    (item) => item.code === "CoveredByKudzu" && item.optedIn
  );
  const isPrimrayKey =
    cards !== null ? (cards !== null ? cards[0].CardKey : 0) : 0;
  const [
    isCoveredByKudzuIneligibleSetupSavings,
    setIsCoveredByKudzuIneligibleSetupSavings,
  ] = useState(false);

  const [isCoveredByKudzuIneligible, setIsCoveredByKudzuIneligible] =
    useState(false);
  const savingsCardExist = cards?.some(
    (item) => item.AccountTypeName === "Savings"
  );
  const savingsWithBalanceOver50 = cards.find(
    (obj) => obj.AccountTypeBit63 == 32 && obj.Balance >= 50
  );
  const AddedAmount = useSelector((state) => state.allocateFund.Installments);
  const AddAccountType = useSelector((state) => state.savingGoalAccountTypeObj);
  const Frequency = useSelector((state) => state.allocateFund.Frequency);
  const selectedDateCopy = useSelector((state) => state.allocateFund.TargetDate);
  const selectedTargetDate = selectedDateCopy != "" ? 
  new Date(selectedDateCopy).getDate() -
  new Date().getDate() ===
1
  ? moment(selectedDateCopy).format("[Tomorrow], dddd, MMMM DD, YYYY")
  : moment(selectedDateCopy).format("dddd, MMMM DD, YYYY") :"";

 


  const RequestObject = useSelector((state) => state.spendAlertsPayload);
  const [activeIndex, setActiveIndex] = useState(-1); // Keep track of the active index
  const manageSavingDataObj = useSelector(
    (state) => state.manageSavingGoalDetailsObj
  );
 

  const allocateFundData = useSelector((state) => state.allocateFund);
  const accessToken = useSelector((state) => state.accessToken);
  const SavingGaolName = useSelector((state) => state.savingGoals.Name);
  const SavingGaolAmount = useSelector((state) => state.savingGoals.Amount);
  const SavingAmount = useSelector((state) => state.savingGoals.SavingAmount);

  

  const { AccountType, AccountName, AccountId, fromAccount } = AddAccountType;
  const selectedFrequencyValueDATA = useSelector(
    (state) => state.selectedFrequencyValue
  );
  const [errorMsg, setErrorMsg] = useState('')
  const [trasferErrorMsg, setTransferErrorMsg] = useState(false)

  const frequecyDataGetting = useSelector((state) => state.frequecyData);

  const [selectedOption, setSelectedOption] = useState(selectedFrequencyValueDATA);
 
  const Code = selectedOption?.Code;
  

  const goalKeyData = useSelector(
    (state) => state.savingGoalResponseData.goalKey
  );
  const [selectedAccountType, setSelectedAccountType] = useState("");
  const accountObj = useSelector((state) => state.accountTypes);
  
  const [NotificationError, setNotificationError] = useState("");
  const { isLocked  } = manageSavingDataObj || '';
  const [lockToggle, setLockToggle] = useState(isLocked);
  const [showToolTip, setShowToolTip] = useState(false);
  const isSavingsGoalsOptedIn = enabledClimbings?.some(item => item.code === SAVINGS_GOALS && item.optedIn)
  const issavingsGoalEligible = enabledClimbings?.find(item => item?.code === SAVINGS_GOALS);

 // for start date and end dates
  const [CalendarMinDate, setCalendarMinDate] = useState('');    
  const [CalendarMaxDate, setCalendarMaxDate] = useState('');
  const selectedStartDateCopy = useSelector((state) => state.allocateFund.StartDate);
  const SelectedStartDate =
  selectedStartDateCopy != "" ? 
  new Date(selectedStartDateCopy).getDate() -
  new Date().getDate() ===
1
  ? moment(selectedStartDateCopy).format("[Tomorrow], dddd, MMMM DD, YYYY")
  : moment(selectedStartDateCopy).format("dddd, MMMM DD, YYYY") :"";



  const selectedEndDateCopy = useSelector((state) => state.allocateFund.EndDate);
  const selectedEndDate = selectedEndDateCopy != "" ? 
  new Date(selectedEndDateCopy).getDate() -
  new Date().getDate() ===
1
  ? moment(selectedEndDateCopy).format("[Tomorrow], dddd, MMMM DD, YYYY")
  : moment(selectedEndDateCopy).format("dddd, MMMM DD, YYYY") :"";



  const [targetDateErrorMsg, setTargetDateErrorMsg] = useState("");
  const [startDateErrorMsg, setStartDateErrorMsg] = useState("");
  const [endDateErrorMsg, setEndDateErrorMsg] = useState("");
 
 

  const NotificationTypeSMS = useSelector((state) => state.allocateFund.sms);
  const NotificationTypeEmail = useSelector(
    (state) => state.allocateFund.email
  );

  const [notificationArray, setNotificationArray] = useState([
    { displayText: t("text"), isSelected: NotificationTypeSMS },
    { displayText: t("email"), isSelected: NotificationTypeEmail },
  ]);
  const valueData = NotificationTypeSMS
    ? NotificationTypeSMS
    : NotificationTypeEmail
    ? NotificationTypeEmail
    : null;
  const setNotificationFun = (option) => {
    setNotificationError("");
    const selectedIndex = notificationArray.findIndex(
      (item) => item.displayText === option.displayText
    );

    notificationArray[selectedIndex] = {
      ...option,
      isSelected: !option?.isSelected,
    };
    setNotificationArray([...notificationArray]);

    if (option.displayText === "Email") {
      dispatch({
        type: "ALLOCATE_FUND",
        payload: {
          key: "email",
          value:
            option?.isSelected !== undefined ? !option?.isSelected : valueData,
        },
      });
    } else {
      dispatch({
        type: "ALLOCATE_FUND",
        payload: {
          key: "sms",
          value:
            option?.isSelected !== undefined ? !option?.isSelected : valueData,
        },
      });
    }
  };

  

  const handleClimbFeatures = async () => {
    if (cards == null || cards == undefined) {
      return;
    }
    setIsLoading(true);
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_CLIMB_FEATURES.replace("{CARD_KEY}", isPrimrayKey);
    const response = await GetRequest(url, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
      //  debugger;
      const spendingAlertResponse = responseJson.Response.find(
        (obj) => obj.code === SPENDING_ALERT
      );
      if (spendingAlertResponse) {
        const isOptInValue = spendingAlertResponse.optedIn;
        // (isOptInValue === false) ? setShowSubItems(true) : setShowSubItems(false);
        setSpendingAlertCode(spendingAlertResponse.code);
        setIsOptIn(isOptInValue);
        setShowSubItems(isOptInValue);
      } else {
        // Handle the case where 'SpendingAlert' is not found in the response
      }
      const enabledClimbings = responseJson.Response.filter(
        (response) => response.enabled === true
      );
      setisClimbings(enabledClimbings);
      setIsLoading(false);
    } else {
      return [];
    }
  };

 

  useEffect(() => {
    handleClimbFeatures();
  }, [showSubItems, isOptIn, SpendingCount]);

  const [isOptInModalOpen, setIsOptInModalOpen] = useState(false);

  const closeOptInModal = () => {
    setIsOptIn((prev) => !prev);
    setIsOptInModalOpen(false);
  };

  ///////////////////////////////////HANDLE PAUSE AND RESUME MODAL POPUS  4

  const ManageSettingsbuttonLabels = [
    { label: "SpendSense Alerts", link: "/Climb/ManageSpendAlerts" },
    {
      label: "Covered by Kudzu",
      link: isCoveredByKudzuOptedIn
        ? "/Climb/ManageCoveredByKudzu"
        : "/Climb/CoveredByKudzu",
    },
    { label: "Savings Habits", link: "/Climb/ManageSavingsHabit" },
    ...(issavingsGoalEligible ? [{ label: 'Savings Goals', link: isSavingsGoalsOptedIn ? '/Climb/SavingGoals/ManageSavingGoal' : '/Climb/ClimbSettings' }] : []),

  ];

  const data = useSelector((state) => state.manageSavingData);

  const ManageSavingTotalCount = useSelector(
    (state) => state.manageSavingTotalCount
  );

  const navigateClicked = (item) => {
    if (item.link == "/Climb/ManageSavingsHabit") {
      if (!savingsCardExist && item.label == "Savings Habits") {
        closeOptInModal();
        setIsCoveredByKudzuIneligibleSetupSavings(true);
      } else if (
        savingsCardExist &&
        savingsWithBalanceOver50 == undefined &&
        item.label != "Savings Habits"
      ) {
        closeOptInModal();
        setIsCoveredByKudzuIneligible(true);
      } else {
        navigate(item.link);
      }
    } else {
      navigate(item.link);
    }
  };
  const openRemoveDoubleCheck = (value) => {
    setErrorModalDouble(true);
  };

  const closeSuccessfullRemoveDone = () => {
    navigate('/Climb/SavingGoals/ManageSavingGoal')
    setDoneModalOpen(false);
    setErrorModalConfirm(false);
  };
  
  const handleDone = (transferBtn) => {
    if (transferBtn === "success") {
      setDoneModalOpen(true);
      setErrorModalConfirm(false);
    }else{
      setErrorModalConfirm(false);
      setTransferErrorMsg(true)
      setErrorMsg(transferBtn)
    }

  };

  const closeRemoveDoubleCCheck = () => {
    setErrorModalDouble(false);
  };
  const closeRemoveDoubleConfirm = () => {
    dispatch({ type: "RESET_ALLOCATE_FUND" })
    dispatch({ type: "RESET_SAVING_GOALS" })
    navigate("/Climb/SavingGoals/ManageSavingGoal");
  };
  const closeRemoveDoubleConfirm1 = () => {
    setErrorModalConfirm(false);
  };

  const closeSuccessfullRemoveConfirm = () => {
    setErrorModalConfirm(false);
  };
  const totalAmount = data?.reduce((sum, item) => sum + item.amount, 0);

  const formattedAmount = totalAmount?.toFixed(2);
  const [beforeDecimal, afterDecimal] = formattedAmount?.split(".");

  const onEdit1 = (value, type, index) => {
    setActiveIndex(index);
  };

  const setFrequencyFun = (value) => {
    setSelectedAccountType(value);
    dispatch({
      type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
      payload: { savingGoalAccountTypeObj: value },
    });
  };

  const dataSubItemTwo =[
      {
         title: "Amount Saving",
         value: `$${AddedAmount}`,
         edit: "Edit Amount",
         onEdit: () => onEdit1(AddedAmount, "AllocateFundAmount", 1),
         type: "AmountSaving",
       }
  ]

  

  const datas = [
    {
      title: "goal name",
      value: SavingGaolName,
      edit: "Edit Goal Name",
      onEdit: () => onEdit1(SavingGaolName, "SavingGoalName", 1),
      type: "Name",
    },
    {
      title: "Target Amount",
      value: `$${SavingGaolAmount}`,
      edit: "Edit Amount",
      onEdit: () => onEdit1(SavingGaolAmount, "SavingGaolAmount", 2),
      type: "Amount",
    },
    // {
    //   title: "Target Date",
    //   value: `${StartDate}`,
    //   edit: "Edit Target Date",
    //   onEdit: () => onEdit1(StartDate, "SavingGaolAmount", 3),
    //   type: "TargetDate",
    // },
    // {
    //   title: "installments",
    //   value: `$${AddedAmount}`,
    //   edit: "Edit Amount",
    //   onEdit: () => onEdit1(AddedAmount, "AllocateFundAmount", 4),
    //   type: "Installments",
    // },
    // {
    //   title: "frequency",
    //   value: DisplayText,
    //   edit: "Edit Frequency",
    //   onEdit: () => onEdit1(DisplayText, "Frequency", 5),
    //   type: "Frequency",
    // },
    
  ];

const onStartDateChange = (date) => {
  const dateObj = new Date(date);
  const targetDateObj = selectedTargetDate ? new Date(selectedTargetDate) : null;

  if (targetDateObj && dateObj > targetDateObj) {
    setStartDateErrorMsg(`The start date must be on or before the Saving Goal target date (${targetDateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    })})`);
  } else {
    setStartDateErrorMsg("");
  }

  dispatch({
    type: "ALLOCATE_FUND",
    payload: { key: "StartDate", value: date },
  });

  dispatch({
    type: "ALLOCATE_FUND",
    payload: { key: "EndDate", value: "" },
  });

  setTargetDateErrorMsg("");
  setEndDateErrorMsg("");
};


const onEndDateChange = (date) => {
  const dateObj = new Date(date);
  const targetDateObj = selectedTargetDate ? new Date(selectedTargetDate) : null;
  const startDateObj = SelectedStartDate ? new Date(SelectedStartDate) : null;

  if (targetDateObj && dateObj > targetDateObj) {
    setEndDateErrorMsg(`The end date must be on or before the Saving Goal target date (${targetDateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    })})`);
  } else if (startDateObj && dateObj < startDateObj) {
    setEndDateErrorMsg("End date cannot be earlier than start date");
  } else {
    setEndDateErrorMsg("");
  }

  dispatch({
    type: "ALLOCATE_FUND",
    payload: { key: "EndDate", value: date },
  });

  setTargetDateErrorMsg("");
  setStartDateErrorMsg("");
};


const onTargetDateChange = (date) => {
  const dateObj = new Date(date);
  const startDateObj = SelectedStartDate ? new Date(SelectedStartDate) : null;
  
  if (startDateObj && dateObj < startDateObj) {
    setTargetDateErrorMsg(`The target date cannot be before Start date. (${startDateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    })})`);
    
  } else {
    setTargetDateErrorMsg("");
  }

  dispatch({
    type: "ALLOCATE_FUND",
    payload: { key: "TargetDate", value: date },
  });

  setStartDateErrorMsg("");
  setEndDateErrorMsg("");
};



  const manageSavingDataObjk = useSelector(
    (state) => state.manageSavingGoalDetailsObj
  );

  const handleBackClick = () => {
    logFirebaseEvents(
      "Allocate_Fund",
      "Back_Allocate_Fund_Save_Clicked",
      "Back_Allocate_Fund_Save_Clicked",
      "",
      ""
    );

    const safeTargetAmount = SavingGaolAmount 
    ? Number(SavingGaolAmount) 
    : manageSavingDataObj?.targetAmount 
      ? Number(manageSavingDataObj.targetAmount) 
      : 0;

  const safeGoalName = SavingGaolName || manageSavingDataObj?.goalName || "";

  dispatch({
    type: "MANAGE_SAVING_GOAL_DETAILS_OBJ",
    payload: { 
      manageSavingGoalDetailsObj: {
        ...manageSavingDataObj,
        goalName: safeGoalName,
        targetAmount: safeTargetAmount
      }
    },
  });

    navigate("/Climb/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails");
  };


  const GetSavingAndSpendingBalance = async (CardKey) => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_BALANACE_ALLOCATE(CardKey);
    try {
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) { 
        
            dispatch({
              type: "MAIN_BALANCE",
              payload: { mainBalance: responseJson.Response },
            });
          
      }
    } catch (error) {
      console.log("error", error);
    }
  }


  const handleSaveAlertsClick = async () => {
  //   const amount = parseFloat(AddedAmount); // Converts string or number to a float
  // if (isNaN(amount) || amount === 0 || amount === 0.00) {
  //   setInstallmentErrMsg("Amount is required");
  //   return;
  // } else {
  //   setInstallmentErrMsg(""); // Clear the error message when AddedAmount is not zero
  // }



    if (!RequestObject.sms && !RequestObject.email) {
      setNotificationError("Choose Notification Type");
      return;
    }
    dispatch({
      type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
      payload: { savingGoalAccountTypeObj: selectedAccountType },
    });
    const modifiedData = {
      goalName: SavingGaolName,
      isLocked: lockToggle,
      fromAccount: AccountId,
      fromAccountType: AccountType,
      targetAmount: SavingGaolAmount,
      installmentAmount: AddedAmount,
      frequency: Code,
      frequencyType: Code == "OT" ? Code : "RC",
      targetDate:
      selectedTargetDate == "Invalid Date"
          ? ""
          : moment(selectedTargetDate).format("YYYY-MM-DD"),

          ...(SelectedStartDate !== "Invalid Date" && {
            startDate: moment(SelectedStartDate).format("YYYY-MM-DD"),
          }),
        
          ...(Code !== "OT" && selectedEndDate !== "Invalid Date" && {
            endDate: moment(selectedEndDate).format("YYYY-MM-DD"),
          }),
      isEmail: NotificationTypeEmail,
      isSms: NotificationTypeSMS,
    };
      var allocateFundStatus = dateComparison(moment(SelectedStartDate).format('MMMM DD, YYYY'))
                if (allocateFundStatus === "Future") modifiedData.IsScheduledTransfer = true
                else modifiedData.IsScheduledTransfer = false
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards.find(
      (account) => account.AccountTypeBit63 == SAVING_CARD_CODE
    );

    const url = EDIT_MANAGE_SAVIGN_V2(savingsAccount.CardKey, goalKeyData);
    try {
      const response = await PostRequest(url, modifiedData, headers);
      const responseJson = JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        const isSpendingAccount = AccountType === "Spending";
        if (isSpendingAccount) {
          GetSavingAndSpendingBalance(AccountId)
        }
        setSuccessModal(true);
 
      } else {
        setErrorModal(true);

        var arrMessages = responseJson.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        setResponseErrorMsg(displayText);
 
      }
    } catch (error) {
      setErrorModal(true);
      console.log(error);
    }
  };




  const handleTransfer = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards.find(
      (account) => account.AccountTypeBit63 == SAVING_CARD_CODE
    );

    const url = REMOVESAVINGGOAL(savingsAccount.CardKey, goalKeyData);
    const response = await PostRequest(url, null, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
          setDoneModalOpen(true);
          setErrorModalConfirm(false);
    } else {
      var arrMessages = responseJson.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
      setErrorModalConfirm(false);
      setTransferErrorMsg(true)
      setErrorMsg(displayText)
    }
  };

  const handleCloseModal = (value) => {
    setSuccessModal(value);
    setErrorModal(value);
  };

  const handleTranferCloseModal = () =>{
    setSuccessModal(false);
    setErrorModal(false);
    setTransferErrorMsg(false);
    setErrorModalConfirm(false);
  }

  const handleRemoveClickNew = () => {
    openRemoveDoubleCheck(true);
  };

  const removeGoalClick = () => { 

      if (SavingAmount > 0 )
      {
        dispatch({ type: 'ACCOUNT_BALANCE', payload: {accountBalance: null } });
        dispatch({type: 'IS_INTERNAL_ACCOUNT', payload:{isInternalAccount: false}});
        setErrorModalDouble(false);
        setErrorModalConfirm(true); 
      }else{
        handleTransfer()
      }
    
  };

  const handleTooltip = () => {
    if (isLocked) {
      return null;
    } else {
      if (showToolTip) {
        setShowToolTip(false)
      } else {
        setShowToolTip(true)

      }
    }

  }

  const [isEditingStates, setIsEditingStates] = useState([]);

  const handleSetIsEditingState = (index, isEditing) => {
    const updatedStates = [...isEditingStates];
    updatedStates[index] = isEditing;
    setIsEditingStates(updatedStates);
  };

  const isAnyItemEditing = isEditingStates.some((state) => state === true);

  
  const cardFooter = (
    handleBackClick,
    handleNextClick,
    handleRemoveClick,
    button1,
    button2,
    isNextActive = true
  ) => {
    return (
      <div className="flex flex-row sm:justify-between justify-between items-center md:gap-16 sm:gap-10 sm:mx-0 mx-4 lg:pb-[5rem] md:pb-[4rem] sm:pb-[3rem] pb-[3rem]">
        <div className="md:ml-[80px] lg:ml-[80px] ">
          {/* Remove Button */}
          <button
            className={`font-hanken-grotesk font-[600] sm:font-[700] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] 
                    leading-[26px] sm:leading-[13px] md:leading-[18px] text-[#94C3E8] capitalize ${isLocked ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
            onClick={handleRemoveClick}
            tabIndex={0}
            disabled={isLocked}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleRemoveClick();
            }}
          >
            {`${t("Remove Goal")}`}
          </button>

          {/* Back Button */}
        </div>

        {/* Next Button and Arrow */}
        <div>
          <div className="flex flex-row justify-end gap-4 cursor-pointer items-center">
            <p
              className="font-hanken-grotesk font-[600] sm:font-[700] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] mr-5
                    leading-[26px] sm:leading-[13px] md:leading-[18px] 
                    text-[var(--backdrop-color)] cursor-pointer capitalize"
              onClick={handleBackClick}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleBackClick();
              }}
            >
              {`${t("back")}`}
            </p>
            <button
              className={`font-hanken-grotesk font-[600] sm:font-[700] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] 
                        leading-[26px] sm:leading-[13px] md:leading-[18px] ${
                          !isNextActive
                            ? "text-[var(--nextdrop-color)] opacity-55"
                            : "text-[var(--nextAct-color)]"
                        }`}
              onClick={handleNextClick}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleNextClick();
              }}
              disabled={!isNextActive}
            >
              {`${t("Save")}`}
            </button>
            <img
              src={
                !isNextActive
                  ? appThemeData.NextArrowInactive
                  : appThemeData.RightArrowActive
              }
              alt="arrow"
              className="h-[12px] w-[12px] sm:h-[10px] sm:w-[11px] md:h-[15px] md:w-[17px]"
            />
          </div>
        </div>
      </div>
    );
  };
  // useEffect(()=>{
  //  alert(selectedAccountType)
  // },[])
  

  const children = () => {
    return (
      <>
        <div className="w-full flex justify-center">
          <div className="md:w-[80%] sm:w-[85%] w-full">
            {/* BODY */}
            <div className="lg:mb-[6rem] md:mb-[4rem] sm:mb-[3rem] mb-[4rem] sm:mx-0 mx-4">
              <div className="sm:w-[80%] w-full flex flex-col justify-center">
                {datas &&
                  datas.map((data, index) => {
                    return (
                      <EditAndRemoveGoals
                        lockedToggle={lockToggle}
                        key={index}
                        data={data}
                        onEdit={() => data.onEdit()}
                        isActive={activeIndex === index}
                        setIsEditingState={(isEditing) => handleSetIsEditingState(index, isEditing)}
                      />
                    );
                  })}

               <div className="md:mt-6 sm:mt-4 mb-1 pt-8">
                   <CustomDatePicker
                    selectedDate={selectedTargetDate}
                    onDateChange={(date) => {
                      onTargetDateChange(date, "TargetDate")
                    }}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                   // maxDate={CalendarMaxDate}
                    disabledDates={[]}
                    title="Target Date"
                    hrbg="bg-dropdown-sky"
                    placeHolder={t('Month_Day_Year')}
                  />
                     <div className='my-2 w-full'>
                           {targetDateErrorMsg !== ""  &&  displayErrorMessage(targetDateErrorMsg)}
                       </div>
                </div>

                <div className="mb-8 pb-6">
                {dataSubItemTwo &&
                  dataSubItemTwo.map((data, index) => {
                    return (
                      <>
                      <EditAndRemoveGoals
                        lockedToggle={lockToggle}
                        key={index}
                        data={data}
                        onEdit={() => data.onEdit()}
                        isActive={activeIndex === index}
                        setIsEditingState={(isEditing) => handleSetIsEditingState(index, isEditing)}
                      />

                      {/* <div className='my-2 w-full'>
                      {installmentAmountErrMsg !== ""  &&  displayErrorMessage(installmentAmountErrMsg)}
                     </div> */}
                     </>
                    );
                  })}
                </div>

                <div className="md:mt-5 sm:mt-10 mb-8">
                <CustomDropdown
                 title="Frequency"
                 selectedFrequency={selectedOption?.DisplayText}
                 options={frequecyDataGetting || []}
                 onSelect={(option) => {
                 setSelectedOption(option); 
                 dispatch({
                  type: "SELECTED_FREQUENCY_VALUE",
                  payload: { selectedFrequencyValue: option},
                });
                }}
                disabled={lockToggle}
               /> 
                </div>

                <div className="md:mt-12 sm:mt-10 mb-8">
                  <CustomAllocateFundDropdown
                    options={
                      accountObj.length > 0
                        ? accountObj
                        : [{ Name: t("no_linked_acccounts") }]
                    }
                    title={t("Allocate funds from")}
                    onSelect={setFrequencyFun}
                    selectedAccountType={selectedAccountType}
                    selectedFrequency={AccountName}
                    disabled={lockToggle}
                    hrbg="bg-dropdown-sky"
                  />
                </div>

                  <div className="md:mt-12 sm:mt-10 mb-8 "  style={{pointerEvents: lockToggle ? "none" : "auto"}}>

                   {Code === "OT" ? (
                <>
                    <CustomDatePicker
                    selectedDate={SelectedStartDate}
                    onDateChange={(date) => onStartDateChange(date, "StartDate")}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                   // maxDate={CalendarMaxDate}
                    disabledDates={[]}
                    title="Start Date"
                    hrbg="bg-dropdown-sky"
                    placeHolder={t('Month_Day_Year')}
                  />
                  <div className='my-2 w-full'>
                  {startDateErrorMsg !== ""  &&  displayErrorMessage(startDateErrorMsg)}
                 </div>
               </>
               ) : (
               <>
                <CustomDatePicker
                    selectedDate={SelectedStartDate}
                    onDateChange={(date) => onStartDateChange(date, "StartDate")}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                   // maxDate={CalendarMaxDate}
                    disabledDates={[]}
                    title="Start Date"
                    hrbg="bg-dropdown-sky"
                    placeHolder={t('Month_Day_Year')}
                  />
                  <div className='my-2 w-full'>
                  {startDateErrorMsg !== ""  &&  displayErrorMessage(startDateErrorMsg)}
                 </div>
 
            <div className="md:mt-12 sm:mt-10 mb-8 pt-6"  style={{pointerEvents: lockToggle ? "none" : "auto"}}>
             <CustomDatePicker
             selectedDate={selectedEndDate}
             onDateChange={(date) => onEndDateChange(date, "EndDate")}
             minDate={""}
             //  maxDate={CalendarMaxDate}
             disabledDates={[]}
             title="End Date (OPTIONAL)"
             hrbg="bg-dropdown-sky"
             placeHolder={t('Month_Day_Year')}
             />
             <div className='my-2 w-full'>
                  {endDateErrorMsg !== ""  &&  displayErrorMessage(endDateErrorMsg)}
                 </div>
           </div>
           </>
          )}

                  </div>

                  <div  className={`${
    Code === "OT" ? "md:mt-12" : "md:mt-2"
  } sm:mt-10 mt-12 md:w-[63%]`} style={{pointerEvents: lockToggle ? "none" : "auto"}}>
                    {/* <div className='lg:py-20 md:py-10 sm:py-10 py-12'> */}
                    <CustomRadioButton
                      title={t("spending_alert_notification_title")}
                      options={notificationArray}
                      onSelect={setNotificationFun}
                      fillIcon={checkbox_fill}
                      frequency={notificationArray}
                      nullIcon={appThemeData.isBatCheck}
                      error={NotificationError}
                    />

                    <span
                      className="font-hanken-grotesk text-[12px] leading-[20px] text-[var(--pin-note-clr2)]
                font-normal"
                    >
                      {t("sms_rating")}
                    </span>
                  </div>

                <div className="md:mt-12 sm:mt-10 mt-12 md:w-full justify-center">
                  <hr
                    tabindex="-2"
                    className={` h-[2px] bg-[var(--content-border)] opacity-[50%] border-0 rounded`}
                  />

                  <div className=" flex flex-row justify-between items-center my-[29px]">
                    <div className="">
                    <p className="font-hanken-grotesk rela flex items-center font-[500] text-[14px] leading-[20px] sm:font-[700] sm:text-[12px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[18px] text-[var(--Timeclr)]">
                      {"Lock Goal"} <img src={HelpPlus} alt='' className={`pl-5  ${isLocked ? '' : 'cursor-pointer'}`} onClick={handleTooltip}  />
                    </p>
                     {showToolTip &&
                        <div className={` w-[174px] font-[400] absolute ml-[31px] mt-[10px] font-hanken-grotesk leading-4
                                                                p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                                                                  shadow-lg  z-10 cursor-pointer transition-all duration-1000`} onClick={() => setShowToolTip(false)} >
                          <div className="tooltip-arrow-comparion"></div>
                        {t('Locking_a_Savings_Goal')}
                      </div>
                      }

                    </div>
                    <p className="flex-grow text-right">
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={lockToggle}
                          tabIndex={0}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              event.preventDefault();
                              setLockToggle(event.target.checked);
                            }
                          }}
                          onClick={(e) => {
                            setLockToggle(e.target.checked);
                          }}
                          class="sr-only peer"
                        />
                        <div
                          class="w-[39px] h-[26px] bg-[var(--locktoggleInActiv)] bg-opacity-40
                                     peer-focus:outline-none   
                                      rounded-full peer dark:bg-gray-700 
                                      peer-checked:after:translate-x-full
                                     peer-checked:after:border-[var(--notificationcomunificationpeerChecked)] 
                                      peer-checked:after:bg-[var(--notificationcomunificationpeerChecked)]
                                      peer-checked:after:left-[-1px]
                                      after:content-[''] 
                                      after:absolute after:top-[3px]
                                      after:left-[4px] after:right-0
                                      after:bg-[#779CE5]
                                       after:border-[#779CE5] after:border-[gray-300] 
                                      after:border after:rounded-full after:h-[20px] 
                                      after:w-[20px] after:transition-all
                                       dark:border-gray-600 peer-checked:bg-[var(--locktoggleActive)] peer-checked:bg-opacity-40"
                        ></div>

                        <span
                          class="ml-3 text-sm font-medium text-gray-900
                                     dark:text-gray-300"
                        ></span>
                      </label>
                    </p>
                  </div>
                  <hr
                    tabindex="-2"
                    className={` h-[2px] bg-[var(--content-border)] opacity-[50%] mt-2 border-0 rounded`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER */}
        {cardFooter(
          handleBackClick,
          handleSaveAlertsClick,
          handleRemoveClickNew,
          false,
          `${t("save")}`,
          !isAnyItemEditing && targetDateErrorMsg === "" && startDateErrorMsg === "" && endDateErrorMsg === "" 
        )}

        {/* ---------- */}
      </>
    );
  };

  return (
    <>
      <HomeLayout>
        <ClimbManageSettingsSidebar
          indexBtn={4}
          ManageSettingsbuttonLabels={ManageSettingsbuttonLabels}
          headingMessage={false}
          count={ ManageSavingTotalCount ? ManageSavingTotalCount : 0}
          isShow={true}
          navigateClicked={navigateClicked}
        />
        <div
          className="flex flex-col md:w-[860px] sm:w-[464px]
            w-[100%] animate__animated animate__fadeInRight "
        >
          <DynamicCard
            header={false}
            CardRadius={true}
            cardWidth={width.homeCard}
            HeaderRadius={true}
            footer={true}
            isWhite={appThemeData.isWhiteBgForCard}
            isDarkForKudzu={appThemeData.isDarkBgForCard}
            backgroundColor={"--cardHeading-bg"}
            HeaderContent={
              <>
                <CardHeading heading={"Edit Savings Goal"} />
              </>
            }
          >
            <>{children()}</>
          </DynamicCard>
        </div>

        <Modal
          isOpen={successModal}
          onClose={() => {
            setSuccessModal(false);
            navigate("/Climb/SavingGoals/ManageSavingGoal");
          }}
          alignItems={"items-center"}
          isClimbg={true}
          // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('success')}</p>}
          subtitle={
            <p>
            <span className={SubHeadingStyles}>
              <span className={`${HeadingStyles}`}>{t("success")} </span>
              {t("Your_Saving_Goal_Set")}
            </span>
          </p>
          }
          content={
            <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
              <EditSuccessModal ModalClose={handleCloseModal} />
            </div>
          }
        />
        <Modal
          isOpen={errorModal}
          onClose={(e) => {
            setErrorModal(false);
            // navigate("/Climb/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails");
          }}
          alignItems={"items-center"}
          isClimbg={true}
          title={
            <p className={`${HeadingStyles} hidden sm:flex`}>
              {t("oops_exclamation")}
            </p>
          }
          subtitle={
            <p>
              <span className={`${HeadingStyles} visible sm:hidden`}>
                {t("oops_exclamation")}
              </span>
              <span className={SubHeadingStyles}>{responseErrorMsg}</span>
            </p>
          }
          content={
            <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
              <EditErrorModal ModalClose={handleCloseModal} />
            </div>
          }
        />
                <Modal
          isOpen={trasferErrorMsg}
          onClose={(e) => {
            setTransferErrorMsg(false);
            navigate("/Climb/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails");
          }}
          alignItems={"items-center"}
          isClimbg={true}
      
          subtitle={
            <p>
              {/* <span className={`${HeadingStyles} visible sm:hidden`}>
                {t("oops_exclamation")}
              </span>
              <span className={SubHeadingStyles}>{errorMsg}</span> */}
               <span className={SubHeadingStyles}><span className={`${HeadingStyles}`}>{t('oops_exclamation')} </span>{errorMsg}</span>
            </p>
          }
          content={
            <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
              <TransferErrorModal ModalClose={handleTranferCloseModal} />
            </div>
          }
        />
      </HomeLayout>
      {isLoading && <Loader />}

     {/* if savingAmount is 0 aftern confirm here it needs to success */}
      <Modal
        Fullheight={true}
        isOpen={errorModalDouble}
        onClose={closeRemoveDoubleCCheck}
        alignItems={"items-center"}
        isClimbg={true}
        // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('removeSpednAlert')}</p>}
        subtitle={
          
          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("removeSpednAlert")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
              {t("removeSpednAlert")}
            </span>
            <span className={`${SubHeadingStyles}`}>
              {t("remove_goal_header")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            <SuccesRemoveGoal
              content1={t("remove_Goal_content")}
              btn1={t("remove_goal_btn")}
              btn1Function={removeGoalClick}
              btn2={t("cancel")}
              btn2Function={closeRemoveDoubleCCheck}
            />
          </div>
        }
      />

      {/* if savingAmount is 0 then dont open this modal */}
      <Modal
        isOpen={errorModalConfirm}
        onClose={closeSuccessfullRemoveConfirm}
        alignItems={"items-center"}
        isClimbg={true}
        // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('done_exclamation')}</p>}
        subtitle={
          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("done_exclamation")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
              {t("ok_exclr")}
            </span>
            <span className={`${SubHeadingStyles} !text-[#FFFFFF]`}>
              {t("remove_goal_header_success")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-3 mt-6">
            <SuccessRemoveGoalConfirm
              content1={t("remove_goal_content_success")}
              btn1={t("transfer_remove_goal")}
              transferBtn={handleDone}
              btn2={t("Cancel")}
              btn2Function={closeRemoveDoubleConfirm1}
            />
          </div>
        }
      />

       {/* if saving goals savingAmount is 0 after confirming this need to open */}
      <Modal
        isOpen={doneModal}
        onClose={closeSuccessfullRemoveDone}
        alignItems={"items-center"}
        isClimbg={true}
        // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('done_exclamation')}</p>}
        subtitle={
            <p>
              <span className={`${HeadingStyles} visible sm:hidden`}>
                {t("done_exclamation")}
              </span>
              <span className={`${SubHeadingStyles} !text-[#94C3E8]`}>
                {t("done_exclr")}
              </span>
              <span className={`${SubHeadingStyles} !text-[#FFFFFF]`}>
                {t("saving_goal_del")}
              </span>
            </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-3 mt-6">
            <DoneModalGoalRemove
              content1={
                SavingAmount > 0 ? (
                <div className="flex flex-col gap-5">
                  {
                    AccountType === 'Savings' ?  <p>{t("done_cont")} </p> : AccountType === 'Spending' ? <p>{t('done_cont_spending')}</p> : <p>{t("The_money_for_savingGoal").replace("{ACTIVE_ALERTS}", (AccountName !== undefined ) ? AccountName : '')}</p>
                  }
                  <p className="text-[#FFFFFF] font-medium font-hanken-grotesk text-[20px]">
                    {addLineBreaks(t("cont1"))}
                  </p>
                  <p className="text-[#FFFFFF] font-medium font-hanken-grotesk text-[20px]">
                    {addLineBreaks(t("cont2"))}
                  </p>
                </div> 
                ) : null
              }
              btn1={t("back_climb")}
              btn1Function={() => navigate("/Climb/ClimbMenu")}
              btn2={t("back_saving_goal")}
              btn2Function={closeRemoveDoubleConfirm}
            />
          </div>
        }
      />
    </>
  );
};

export default withOidcSecure(EditManageSaving);